import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { useHistory } from 'react-router-dom';
import { sceneEventBus } from '@/event_bus';
import { useOutlet } from '@/components/router/routes';
import SelectedTopicApi from '@/api/grpcApi/seleceed_topic/selected_topic_api';
import { planExamineList } from '../config';
import './index.less';

const { TabPane } = Tabs;

/**
 * 策划审核页面
 * @returns {JSX.Element}
 */
const PlanExamine: React.FC = () => {
    const history = useHistory();
    const outlet = useOutlet();
    const [total, setTotal] = useState(0);
    const status = 202; // 策划审核

    /**
     * listTopicSceneAddress
     */
    const listTopicSceneAddress = () => {
        SelectedTopicApi().listTopicSceneAddress({ status })
            .then((res: any) => setTotal(res.total))
            .catch((err: any) => {
                throw new Error(err.message);
            });
    };
    // 获取策划审核场景总数
    useEffect(() => {
        listTopicSceneAddress();
    }, []);

    useEffect(() => {
        /**
         * 刷新total
         */
        const reFresh = () => {
            listTopicSceneAddress();
        };

        const off = sceneEventBus.on(reFresh);
        return off;
    }, [sceneEventBus]);

    return (
        <div className="amps-plan-examine-page page-container">
            <Tabs
                tabBarGutter={40}
                animated={false}
                defaultActiveKey="scene"
                onChange={(key) => {
                    history.push(key);
                }}
            >
                {
                    planExamineList.map((item) => (
                        <TabPane tab={`${item.title}(${total})`} key={item.name} />
                    ))
                }
            </Tabs>
            {outlet}
        </div>
    );
};

export default PlanExamine;
